import { applyMiddleware, createStore } from "redux";
import { composeWithDevTools } from "redux-devtools-extension";
import thunk from "redux-thunk";
import rootreducers from "./reducers";

const initialState = {};

const middleware = [thunk];

const store = createStore(
  rootreducers,
  initialState,
  composeWithDevTools(applyMiddleware(...middleware))
);

/* const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware(),
  reducer: rootreducers,

  preloadedState: initialState,
}); */

export default store;
